// extracted by mini-css-extract-plugin
var _1 = "t2Ni";
var _2 = "t2Nj";
var _3 = "t2Nf";
var _4 = "t2Nh";
export { _1 as "hero", _2 as "offer", _3 as "text", _4 as "title" }
